import React from 'react';

import Author from '../../../components/Molecules/Author';
import defaultAvatar from '../../../assets/images/default-avatar.png';

const NodeAuthor = ({ entity, className, isSmall }) => {
  return (
    <Author
      className={className}
      name={entity.getIn(['field_naam_auteur', 0, 'value'], '')}
      workfield={entity.getIn(['field_function', 0, 'value'], '')}
      avatar={entity.getIn(['field_media_image', 0, 'styles', '1_1'], defaultAvatar)}
      isSmall={isSmall}
    />
  );
};

export default NodeAuthor;
